import { jsxs as t, jsx as r } from "react/jsx-runtime";
import "react-hook-form";
import "@material-ui/core";
import "react";
import "uuid";
import { B as i } from "./Button-1eab0617.js";
import { Title as l } from "./Title.js";
function h({ error: o, resetErrorBoundary: e }) {
  return /* @__PURE__ */ t("div", { role: "alert", children: [
    /* @__PURE__ */ r(l, { children: "Oops! Ocorreu algo errado!" }),
    /* @__PURE__ */ r("pre", { className: "my-8 text-red-600", style: { whiteSpace: "break-spaces" }, children: o.message }),
    e ? /* @__PURE__ */ r(i, { onClick: e, children: "Tentar novamente" }) : null
  ] });
}
export {
  h as ErrorFallback
};
